import { 
    CREATETIMELINETYPE, 
    DELETETIMELINETYPE, 
    GETTIMELINETYPE, 
    UPDATETIMELINETYPE
 } from '../actions/types';

const initialState = {
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {

    switch (action.type) {
       
        case CREATETIMELINETYPE:
            return {
                ...state,
                timelinetypeSaveStatus: action.payload.success,
            }
        case GETTIMELINETYPE:
                return {
                        ...state,
                        timelinetypeList: action.payload.data,
                        }
        case UPDATETIMELINETYPE:
                return {
                        ...state,
                        timelinetypeUpdateStatus: action.payload.success,
                        }   

        case DELETETIMELINETYPE:
                 return {
                     ...state,
                     timelinetypeDeleteStatus: action.payload.success,
                        } 
        default:
                return state
                      }
                 }